import { DataRoom } from "@/components/deal-detail/data-lake/data-room";
import type { DealTransformed } from "@/lib/schema/deal-schema";
import { memo } from "react";

interface DataRoomTabProps {
  currentDeal: DealTransformed;
}

function DataRoomTab({ currentDeal }: DataRoomTabProps) {
  // Matches the Profile tab's container sizing so the two tabs feel
  // like peers — wider than the old max-w-3xl so the file list and
  // action row breathe in the new warm-paper layout.
  return (
    <div className="mx-auto max-w-4xl p-6">
      <DataRoom currentDeal={currentDeal} isLoading={false} />
    </div>
  );
}

export default memo(DataRoomTab);
